import React from 'react';
import FilePDFIcon from '@/assets/svg/FilePDF.svg';
import FileJPEGIcon from '@/assets/svg/FileJPEG.svg';
import FileJPGIcon from '@/assets/svg/FileJPG.svg';
import FilePNGIcon from '@/assets/svg/FilePNG.svg';
import FileDOCXIcon from '@/assets/svg/FileDOCX.svg';

/** Pick a file-type icon from the filename extension. Defaults to the PDF icon. */
export const getFileIcon = (filename: string): React.ReactNode => {
  const ext = filename.split('.').pop()?.toLowerCase();
  switch (ext) {
    case 'jpeg':
      return <FileJPEGIcon className="w-9 h-9 shrink-0" />;
    case 'jpg':
      return <FileJPGIcon className="w-9 h-9 shrink-0" />;
    case 'png':
      return <FilePNGIcon className="w-9 h-9 shrink-0" />;
    case 'docx':
      return <FileDOCXIcon className="w-9 h-9 shrink-0" />;
    default:
      return <FilePDFIcon className="w-9 h-9 shrink-0" />;
  }
};

export const openInNewTab = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

/**
 * Download a presigned file via a temporary blob link. Falls back to opening
 * the URL in a new tab if the fetch fails (e.g. CORS).
 */
export const downloadFile = async (
  url: string,
  filename: string
): Promise<void> => {
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) {
      return;
    }
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch {
    openInNewTab(url);
  }
};
